import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Panel } from "@/components/admin/AdminUI";
import { ConfirmDialog } from "@/components/ConfirmDialog";

export const AdminTesters = () => {
  const api = useApi();
  const [rows, setRows] = useState([]);
  const [email, setEmail] = useState("");
  const load = () => api.get("/admin/testers").then((r) => setRows(r.data));
  useEffect(() => { load(); }, [api]); // eslint-disable-line
  const set = async (e, on) => {
    try { await api.post("/admin/testers", { email: e, on }); toast.success(on ? "Test access given" : "Test access removed"); setEmail(""); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Panel title="Test access" sub="While Action Plans are closed, testers can make one Action Plan. After that, they see a thank-you note instead of the start button." testId="access-testers">
      <form onSubmit={(e) => { e.preventDefault(); set(email, true); }} className="flex flex-col sm:flex-row gap-2 mb-4">
        <input type="email" required className="field" placeholder="Their email address" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="tester-email-input" />
        {email.includes("@") && <button className="btn-charcoal shrink-0 fade-in" data-testid="tester-add-btn">Give test access</button>}
      </form>
      {rows.length === 0 ? <p className="text-sm text-ink-soft">No testers yet.</p> : (
        <ul className="space-y-2" data-testid="tester-list">
          {rows.map((r) => (
            <li key={r.email} className="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-alabaster px-4 py-3 text-[15px]" data-testid={`tester-${r.email}`}>
              <span className="min-w-0">
                <span className="block [overflow-wrap:anywhere]">{r.email}</span>
                <span className="block text-sm text-ink-soft">{r.plan_used ? "Plan made" : r.signed_up ? "Signed in, no plan yet" : "Not signed in yet"}</span>
              </span>
              <ConfirmDialog title="Remove test access?" body={`${r.email} won't be able to start a test plan. Any plan they've made stays theirs.`}
                confirmLabel="Remove" cancelLabel="Keep access" calm onConfirm={() => set(r.email, false)} testId={`tester-remove-confirm-${r.email}`}
                trigger={<button className="btn-quiet text-sm" data-testid={`tester-remove-${r.email}`}>Remove</button>} />
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};
